import { Component, OnInit, Input} from '@angular/core';
import { NewsService } from '../../news/news.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ThumbnailPipe } from '../../../../utils/pipe/thumbnail.pipe'; 

@Component({
  selector: 'app-latest-news',
  templateUrl: './latest-news.html',
  styleUrls: ['./latest-news.scss'],
  providers: [ThumbnailPipe]

})
export class LatestNewsComponent implements OnInit {
  
  @Input() pb!: string;
  @Input() pt!: string;
  newsList: any;

  private baseUrl = environment.apiUrl;

  constructor(private router: Router, private NewsService: NewsService, private thumbnailPipe:ThumbnailPipe) { }
  
  goToNews(element: any) {
    this.router.navigate(['/news/view/', element.id]);
  }

  ngOnInit(): void {
      this.NewsService.getNewsByTitleOrContent(1, 3, '').subscribe((response: any) => {


      response.data.forEach((item:string) => {
        item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);

      });
      this.newsList = response.data;
    
    });
  }

  
}
